// extracted by mini-css-extract-plugin
module.exports = {"SepTimeBoard":"SepTimeBoard_SepTimeBoard__1HduD"};